import React from "react";
import { Box, Grid, InputLabel, List } from "@mui/material";
import SectionWrapper from "../pageSections/SectionWrapper";
import ItemsPermissionDetail from "../../common/item/ItemsPermissionDetail";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { get } from "lodash";

interface ItemDetailUserGroupDataProps {
  userGroup: any;
}

const ItemDetailUserGroupData = ({
  userGroup,
}: ItemDetailUserGroupDataProps) => {
  const permissions = useSelector(
    (state: ApplicationState) => state.permission?.data?.data || []
  );

  return (
    <SectionWrapper isChild title="Permissions">
      <Grid item xs={12}>
        <List>
          {Object.keys(permissions || {})
            .filter((key) => get(userGroup, `${key}.Access.R`, false))
            .map((key: string, idx) => {
              return (
                <ItemsPermissionDetail
                  key={key}
                  permissionKey={key}
                  userGroup={userGroup}
                  permissions={permissions}
                />
              );
            })}
        </List>
      </Grid>
    </SectionWrapper>
  );
};

export default ItemDetailUserGroupData;
